module.exports = __webpack_public_path__ + "img/pascal_thun_ocular-2.1ba329c0.jpg";